import { createSlice } from "@reduxjs/toolkit";

export const ProjectRequestIntegrationSlice = createSlice({
  name: "project_request_integration",
  initialState: {
    value: {},
  },
  reducers: {
    updateProjectRequestIntegrationValue: (state, action) => {
      if (action.payload.type) {
        return {
          ...state,
          value: {
            ...state.value,
            [action.payload.type]: action.payload.value,
          },
        };
      } else {
        state.value = action.payload;
      }
    },
    resetProjectRequestIntegrationValue : state => {
      state.value = {};
    }
  },
});

export const { updateProjectRequestIntegrationValue, resetProjectRequestIntegrationValue } = ProjectRequestIntegrationSlice.actions;

export default ProjectRequestIntegrationSlice.reducer;
